var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('p',{staticClass:"mb-3",class:_vm.titleClass},[_vm._v(" "+_vm._s(_vm.$t(_vm.story.title))+" ")]),_c('p',{staticClass:"mb-3",class:_vm.quoteClass},[_c('fa',{attrs:{"icon":"quote-right"}})],1),_c('b-btn',{attrs:{"variant":"light","size":"sm","to":{
            name: ("home" + _vm.routePostfix),
            query: { story: _vm.story.id },
        }}},[_vm._v(" "+_vm._s(_vm.$t('common.buttons.linkStory'))+" ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }